import { Grid, Typography, Button, Input } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

class SuccessScrappedPromo extends React.Component {
  render() {
    return (
      <Grid container direction="column" style={{ justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant="h1" className="mt-1">Success</Typography>
        <Grid style={{}}>
          <CheckCircleOutlineIcon style={{ fontSize: 100, marginTop: 40, color: 'green' }} />
        </Grid>
        <Grid container direction="column" style={{ marginTop: 40, alignItems: 'center' }}>
          <Typography variant="h1" className="mt-4">Add another post for</Typography>
          <Typography variant="h1" className="mt-1">
            {this.props.name}
            ?
          </Typography>
        </Grid>
        <Grid container direction="column" className="mt-5" style={{ alignItems: 'center' }}>
          <Button
            variant="contained"
            style={{ height: 40, width: '75%' }}
            onClick={() => this.props.onSelectYes()}
          >
            <Typography variant="h6">Yes</Typography>
          </Button>
          <Button
            variant="contained"
            style={{ height: 40, width: '75%' }}
            className="mt-5"
            onClick={() => this.props.onSelectNo()}
          >
            <Typography variant="h6">No</Typography>
          </Button>
        </Grid>
      </Grid>
    );
  }
}

export default connect(null, null)(SuccessScrappedPromo);
